// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".colPopovers{padding:5px 0}.colPopovers .col_operation .whole{height:30px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;padding:5px 15px}.colPopovers .col_operation .whole .operation{width:100%;cursor:pointer}.colPopovers .col_operation .whole:hover{color:#fff;background-color:#ccc}", ""]);
// Exports
module.exports = exports;
